<section class="small d-none sectionClass" style="background-color: #ccd3ca">
  <div class="container">
    <div class="row">
      <div class="col-md-5 col-lg-5 col-sm-5">
        <ul class="nav">
          <li class="nav-item">
            <a
              class="nav-link py-0 px-2"
              [routerLink]="['/multimedia/feedback']"
              routerLinkActive="active"
              >Skip to main content</a
            >
          </li>
          <li class="border_spacing">
            <div class="difference"></div>
          </li>
          <li class="nav-item">
            <a
              class="nav-link py-0 px-2"
              routerLinkActive="active"
              routerLink="/sitemap"
              >Sitemap</a
            >
          </li>
          <li class="border_spacing">
            <div class="difference"></div>
          </li>
          <li class="nav-item">
            <a class="nav-link py-0 px-2" routerLinkActive="active"
              >Screen Reder Access</a
            >
          </li>
        </ul>
      </div>
      <div class="col-md-7 col-lg-7 col-sm-7">
        <ul class="nav justify-content-end">

          <li class="nav-item" (click)="hideOtherModule()">
            <ng-container *ngFor="let data of textSize">
              <span
                (click)="setFontSize(data)"
                class="text-{{ data }} textIcon"
                style="cursor: pointer; border: none"
                [ngClass]="currentTextSize == data ? 'active' : ''"
                >A</span
              >
            </ng-container>
          </li>
          <li class="border_spacing">
            <div class="difference"></div>
          </li>
          <li class="nav-item" (click)="hideOtherModule()">
            <a
              href="https://www.facebook.com/aajeevika"
              target="_blank"
              class="nav-link py-0 px-2"
            >
              <img
                src="../../../assets/images/fbIcon-shg.svg"
                class="img-fluid"
                alt=""
              />
            </a>
          </li>

          <li class="nav-item" (click)="hideOtherModule()">
            <a
              href="https://twitter.com/DAY_NRLM"
              target="_blank"
              class="nav-link py-0 px-2"
            >
              <img
                src="../../../assets/images/twitIcon-shg.svg"
                class="img-fluid"
                alt=""
              />
            </a>
          </li>

          <li class="nav-item" (click)="hideOtherModule()">
            <a
              href="http://www.youtube.com/user/aajeevikaNRLM"
              target="_blank"
              class="nav-link py-0 px-2"
            >
              <img
                src="../../../assets/images/ytIcon-shg.svg"
                class="img-fluid"
                alt=""
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
<section class="py-2 bg-white">
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <img
          src="../../../assets/images/nrlmLogo-shg.svg"
          class="img-fluid"
          alt=""
        />
      </div>

      <div>
        <img
          src="/assets/images/NewMord.png"
          style="max-width: 240px"
          alt="Deendayal Antyodaya Yojana"
          title="Deendayal Antyodaya Yojana"
          class="img-fluid"
        />
      </div>

    </div>
  </div>
</section>
<nav
  class="navbar navbar-expand-lg navbar-dark bg-primary nav-primary"
  *ngIf="!hasRoute('admin')"
  style="display: none"
>
  <div class="container">
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarText"
      aria-controls="navbarText"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item" (click)="openHome()">
          <a
            class="nav-link"
            aria-current="page"
            routerLinkActive="active"
            routerLink="/home"
            >Home</a
          >
        </li>

        <li class="nav-item" (click)="openDashboard()">
          <a
            class="nav-link"
            href="https://lookerstudio.google.com/u/0/reporting/c6e6022d-9eb7-4aeb-83c3-ed08947f6c82/page/p_n91sk52duc"
            target="_blank"
            >Dashboard</a
          >
        </li>

        <li
          class="nav-item dropdown"
          routerLinkActive="active"
          (click)="openAboutDropdown()"
        >
          <a
            class="nav-link dropdown-toggle dropdown dropdown-6"
            id="aboutUs"
            role="button"
            aria-expanded="false"
            [style.color]="aboutUsSubDropdown === true ? '#fff' : '#cba6a6'"
          >
            About Us
          </a>
          <ul
            class="dropdown_menu dropdown_menu--animated dropdown_menu-6"
            [style.display]="aboutUsDropdown === true ? 'block' : 'none'"
            aria-labelledby="aboutUs"
          >
            <li
              class="dropdown-ele"
              [class.selectedList]="router.url == '/about/introduction'"
              routerLink="/about/introduction"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                aria-controls="navbarText"
                aria-expanded="false"
                (click)="openAboutusSubDropdown()"
                >Introduction</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="router.url == '/about/founding-philosophy'"
              routerLink="/about/founding-philosophy"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                (click)="openAboutusSubDropdown()"
                >Founding Philosophy</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="router.url == '/about/genesis'"
              routerLink="/about/genesis"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openAboutusSubDropdown()"
                >Genesis</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="router.url == '/about/goal'"
              routerLink="/about/goal"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openAboutusSubDropdown()"
                >Goal</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="router.url == '/about/guiding-principles'"
              routerLink="/about/guiding-principles"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openAboutusSubDropdown()"
                >Guiding Principles
              </a>
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="router.url == '/about/values'"
              routerLink="/about/values"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openAboutusSubDropdown()"
                >Values</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="router.url == '/about/team'"
              routerLink="/about/team"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openAboutusSubDropdown()"
                >Team</a
              >
            </li>
          </ul>
        </li>

        <li class="nav-item dropdown" (click)="openWhatDropdown()">
          <a
            class="nav-link dropdown-toggle dropdown dropdown-6"
            routerLinkActive="active"
            id="whatWeDo"
            role="button"
            aria-expanded="false"
            [style.color]="whatSubDropdown === true ? '#fff' : '#cba6a6'"
          >
            What We Do
          </a>
          <ul
            class="dropdown_menu dropdown_menu--animated dropdown_menu-6"
            aria-labelledby="whatWeDo"
            [style.display]="whatDropdown === true ? 'block' : 'none'"
          >
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url == '/what-we-do/institutional-capacity-building'
              "
              routerLink="/what-we-do/institutional-capacity-building"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWhatSubDropdown()"
                >Institutional Building and Capacity Building</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url ==
                '/what-we-do/social-inclusion-and-social-development'
              "
              routerLink="/what-we-do/social-inclusion-and-social-development"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWhatSubDropdown()"
                >Social Inclusion and Social Development</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url == '/what-we-do/universal-financial-inclusion'
              "
              routerLink="/what-we-do/universal-financial-inclusion"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWhatSubDropdown()"
                >Universal Financial Inclusion</a
              >
            </li>
            <li
              class="dropdown-ele"
              class="dropdown-ele"
              [class.selectedList]="router.url == '/what-we-do/livelihoods'"
              routerLink="/what-we-do/livelihoods"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWhatSubDropdown()"
                >Livelihoods</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url == '/what-we-do/monitoring-system-and-mis'
              "
              routerLink="/what-we-do/monitoring-system-and-mis"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWhatSubDropdown()"
                >Programme Management</a
              >
            </li>
            <li
              routerLink="/what-we-do/national-rural-economic-transformation-project"
              class="dropdown-ele"
              [class.selectedList]="
                router.url ==
                '/what-we-do/national-rural-economic-transformation-project'
              "
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWhatSubDropdown()"
                >National Rural Economic Transformation Project</a
              >
            </li>
          </ul>
        </li>
        <!--  -->
        <li class="nav-item dropdown" (click)="openWorkStructureDropdown()">
          <a
            class="nav-link dropdown-toggle dropdown dropdown-6"
            id="workStructure"
            role="button"
            routerLinkActive="active"
            aria-expanded="false"
            [style.color]="
              workStructureSubDropdown === true ? '#fff' : '#cba6a6'
            "
          >
            Work Structure
          </a>
          <ul
            class="dropdown_menu dropdown_menu--animated dropdown_menu-6"
            aria-labelledby="workStructure"
            [style.display]="workStructureDropdown === true ? 'block' : 'none'"
          >
            <li
              class="dropdown-ele"
              [class.selectedList]="router.url == '/work-structure/approach'"
              routerLink="/work-structure/approach"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWorkstructureSubDropdown()"
                >Approach</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url == '/work-structure/support-units'
              "
              routerLink="/work-structure/support-units"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWorkstructureSubDropdown()"
                >Support Units</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url == '/work-structure/resource-blocks'
              "
              routerLink="/work-structure/resource-blocks"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWorkstructureSubDropdown()"
                >Resource Blocks</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url == '/work-structure/intensive-blocks'
              "
              routerLink="/work-structure/intensive-blocks"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWorkstructureSubDropdown()"
                >Intensive Blocks</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url == '/work-structure/partnership-blocks'
              "
              routerLink="/work-structure/partnership-blocks"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWorkstructureSubDropdown()"
                >Partnership Blocks</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url == '/work-structure/non-intensive-blocks'
              "
              routerLink="/work-structure/non-intensive-blocks"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWorkstructureSubDropdown()"
                >Non-Intensive Blocks</a
              >
            </li>
            <li
              class="dropdown-ele"
              [class.selectedList]="
                router.url == '/work-structure/exit-strategy'
              "
              routerLink="/work-structure/exit-strategy"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                routerLinkActive="active"
                (click)="openWorkstructureSubDropdown()"
                >Exit Strategy</a
              >
            </li>
          </ul>
        </li>
        <!--  -->
        <li class="nav-item dropdown" (click)="openImpactDropdown()">
          <a
            class="nav-link dropdown-toggle dropdown dropdown-6"
            id="ourImpact"
            role="button"
            aria-expanded="false"
            [style.color]="ourImpactSubDropdown === true ? '#fff' : '#cba6a6'"
          >
            Our Impact
          </a>
          <ul
            class="dropdown_menu dropdown_menu--animated dropdown_menu-6"
            aria-labelledby="ourImpact"
            [style.display]="impactDropdown === true ? 'block' : 'none'"
          >
            <li
              routerLink="/our-impact/overview"
              routerLinkActive="active"
              [class.selectedList]="router.url == '/our-impact/overview'"
              class="dropdown-ele"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                (click)="openOurImpactSubDropdown()"
                >Overview</a
              >
            </li>
            <li
              routerLinkActive="active"
              routerLink="/our-impact/success-stories"
              [class.selectedList]="router.url == '/our-impact/success-stories'"
              class="dropdown-ele"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                (click)="openOurImpactSubDropdown()"
                >Success Stories</a
              >
            </li>
          </ul>
        </li>

        <li class="nav-item dropdown" (click)="openResourceDropdown()">
          <a
            class="nav-link dropdown-toggle dropdown dropdown-6"
            id="resourceCentre"
            role="button"
            aria-expanded="false"
            [style.color]="resourceSubDropdown === true ? '#fff' : '#cba6a6'"
          >
            Resource Centre
          </a>
          <ul
            class="dropdown_menu dropdown_menu--animated dropdown_menu-6"
            aria-labelledby="resourceCentre"
            [style.display]="resourceDropdown === true ? 'block' : 'none'"
          >
            <li
              routerLinkActive="active"
              class="dropdown-ele"
              [class.selectedList]="activeButton === item?.subModuleName"
              (click)="getToResourceSubModule(item); openResourceSubDropdown()"
              style="cursor: pointer"
              *ngFor="let item of resourceSubModules"
            >
              <a
                class="dropdown-item"
                data-bs-toggle="collapse"
                data-bs-target="#navbarText.show"
                >{{ item.subModuleName }}</a
              >
            </li>
          </ul>
        </li>

        <li class="nav-item" routerLink="/join-us" routerLinkActive="active">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            data-bs-target="#navbarText.show"
            (click)="openCareers()"
            >Careers</a
          >
        </li>
      </ul>
      <ul class="nav">
        <li class="nav-item d-flex" *ngIf="!isLoginPage">
          <form
            [formGroup]="searchForm"
            class="d-flex bg-white rounded searchForm"
            (ngSubmit)="enterSubmit($event, searchForm.value)"
          >
            <input
              type="text"
              name="searchForm"
              id="searchFormInput"
              class="form-control border-0"
              formControlName="searchValue"
              placeholder="search..."
            />
            <button class="btn btn-link">
              <i class="fa fa-search icon"></i>
            </button>
          </form>
        </li>
      </ul>
    </div>
  </div>
</nav>

<nav class="nav-ajvk navbar navbar-expand-lg bg-primary nav-primary">
  <div class="container">
    <div *ngIf="isLoggedIn && !locationHome" class="d-flex flex-row justify-content-between" style="width: 100%;">
      <ng-container>
        <ul class="nav-ele d-flex flex-row" style="list-style: none; padding: 0; margin: 0;">
          <button mat-raised-button *ngIf="isLoggedIn && !locationHome" routerLink="/home" style="font-size: small; font-weight: 400; margin-right: 20px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 32 32">
              <path d="M 16 2.59375 L 15.28125 3.28125 L 2.28125 16.28125 L 3.71875 17.71875 L 5 16.4375 L 5 28 L 14 28 L 14 18 L 18 18 L 18 28 L 27 28 L 27 16.4375 L 28.28125 17.71875 L 29.71875 16.28125 L 16.71875 3.28125 Z M 16 5.4375 L 25 14.4375 L 25 26 L 20 26 L 20 16 L 12 16 L 12 26 L 7 26 L 7 14.4375 Z" fill="#2DBE5A"></path>
            </svg>
            <!-- Home -->
          </button>
          <li *ngIf="geoData?.stateName" style="font-size: small; font-weight: 400; margin-right: 20px;">State: {{ geoData?.stateName }}</li>
          <li *ngIf="geoData?.districtName" style="font-size: small; font-weight: 400; margin-right: 20px;">District: {{ geoData?.districtName }}</li>
          <li *ngIf="geoData?.blockName" style="font-size: small; font-weight: 400; margin-right: 20px;">Block: {{ geoData?.blockName }}</li>
        </ul>
      </ng-container>

      <ng-container>
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li *ngIf="geoData?.username" style="font-size: small; font-weight: 400;">Username: {{ geoData?.username }}</li>
        </ul>
      </ng-container>
    </div>

    <div
    *ngIf="!isLoggedIn || locationHome"
      class="row navbar-collapse"
      id="navbarSupportedContent"
      style="background-color: #0c57f6"
    >
      <div
        class="d-sm-flex align-items-center justify-content-between"
        style="background-color: #e58741; width: 100%"
      >
        <ul class="cust-navbar">
          <ng-container>
            <li routerLinkActive="active" class="nav-ele" (click)="openHome()">
              <a routerLink="/home">Home</a>
            </li>
            <li routerLinkActive="active" class="nav-ele">
              <a routerLink="/about">About</a>
            </li>
            <li routerLinkActive="active" class="nav-ele">
              <a routerLink="/resources">Resource Centre</a>
            </li>

            <li routerLinkActive="active" class="nav-ele" (click)="openReports()">
              <a

                >Reports</a
              >
            </li>
          </ng-container>
        </ul>
        <ng-container>
          <!-- <div *ngIf="!isLoggedIn && !geoData"
               class="btn btn-sm"
               style="border-radius: 5px"
               id="login-active"
               routerLinkActive="active"
               routerLink="/login">
            <p class="login-text">Login</p>
          </div>

          <div *ngIf="isLoggedIn && geoData"
               class="btn btn-sm"
               style="border-radius: 5px"
               id="login-active"
               routerLinkActive="active"
               [routerLink]="getRouterLink(geoData?.levelId)"
               (click)="resetReportsClick()">
            <p class="login-text">Go to Portal</p>
          </div> -->

          <div *ngIf="!isLoggedIn && geoData == null"
          class="btn btn-sm"
          style="border-radius: 5px"
          id="login-active"
          routerLinkActive="active"
          routerLink="/login"
        >
          <p class="login-text">Login</p>
        </div>
          <!-- LevelId == 1  -->
          <div *ngIf="isLoggedIn && geoData != null && geoData?.levelId == 1"
            class="btn btn-sm"
            style="border-radius: 5px"
            id="login-active"
            routerLinkActive="active"
            routerLink="/admin/bank-admin/bank-list"
            (click)="resetReportsClick()"
          >
            <p class="login-text">Go to Portal</p>
          </div>

          <div *ngIf="isLoggedIn && geoData != null && geoData?.levelId == 5 || geoData?.levelId == 4 || geoData?.levelId == 3 || geoData?.levelId == 2"
          class="btn btn-sm"
          style="border-radius: 5px"
          id="login-active"
          routerLinkActive="active"
          routerLink="/admin/loan/loan-list"
          (click)="resetReportsClick()"
        >
          <p class="login-text">Go to Portal</p>
        </div>
        <div *ngIf="isLoggedIn && geoData != null && geoData?.levelId == 8 || geoData?.levelId == 7 || geoData?.levelId == 6"
        class="btn btn-sm"
        style="border-radius: 5px"
        id="login-active"
        routerLinkActive="active"
        routerLink="/admin/pending"
        (click)="resetReportsClick()"
        >
        <p class="login-text">Go to Portal</p>
        </div>
        </ng-container>

      </div>
    </div>
  </div>
</nav>
